<template>
	<nk-page commercialAccess="Warehouse" :policyClaims="['Warehouse_ProductWarehouse_Management']">
		<template #badges>
			<nk-badge system="sale">
				<nk-badge-item type="system" modelValue="sale"></nk-badge-item>
				<nk-badge-item type="system" modelValue="sale" :title="$t('forms.Warehouse')"></nk-badge-item>
			</nk-badge>
		</template>
		<ag-grid :options="tableOptions" :data="warehouses" :key="warehouses.length" v-model="selectedRow" @row_dbClicked="rowDbClicked" @preSelectedRowData="preSelectedRowData" ref="warehouseList" tabindex="101" startup></ag-grid>

	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import Input from '~/components/general/nikan-input.vue'
	import $sc from '~/plugins/shortcut.collection'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import { mapGetters, mapActions, mapState } from 'vuex'
	import validators from '~/statics/validators'
	import emptyId from '~/statics/empty-id'
	import WarehouseModify from '~/views/sale/warehouse/warehouse-modify.vue'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'

	export default {
		name: 'warehouse',
		modal: {
			size: 'md',
			stateUID: 'warehouse',
			helpTag: 'WarehouseList'
		},
		props: {
			data: { type: Array, default: () => [] },
			options: { type: Object },
		},
		data() {
			return {
				settings: {
					data: []
				},
				localSelectedItem: null,
				selectedRow: null,
				editableButtons: null,
				tableOptions: {
					id: this.$options.name,
					focusAndSelect: {
						allowFocus: true
					},
					doubleClickedToSelect: false,
					rowGroupPanelShow: false,
					groupIncludeTotalFooter: false,
					cellSelectionAggReport: false,
					pagination: false,
					fitToWidth: true,
					sideBar: 'none',
					rowSelection: {
						mode: 'singleRow'
					},
					columnDefs: [
						{
							field: 'rowNumber',
							headerName: this.$t('row-number'),
							cellClass: 'text-center',
							headerClass: ' text-center',
						},
						{
							field: 'code',
							headerName: this.$t('sale.warehouse.f.code'),
							cellClass: 'text-center',
							headerClass: ' text-center',
						},
						{
							field: 'name',
							headerName: this.$t('sale.warehouse.f.name'),
							cellClass: 'text-center',
							headerClass: ' text-center',
						},
						{
							field: 'type',
							headerName: this.$t('sale.warehouse.f.type'),
							contentType: 'enum',
							valueFormatter: data => {
								return data.value && this.$t('sale.warehouse.types.' + data.value.toLowerCase())
							},
							cellClass: 'text-center',
							headerClass: ' text-center',
						},
					],


				},
				pageButtons: {
					selectButton: {
						title: this.$t('select'),
						shortcut: $sc.find('enter-only'),
						element: () => this.$refs.warehouseList.$el,
						icon: 'check',
						isPrimary: true,
						visible: (this.options || {}).selectable,
						disabled: false,
						handle: (button, page, e) => {
							if (_.isEmpty(this.selectedRow))
								return this.$toast(this.$t('document.m.select-row'))

							this.resolve(this.selectedRow)
						}
					},
					editButton: {
						title: this.$t('sale.warehouse.f.edit'),
						shortcut: $sc.find('edit'),
						visible: true,
						icon: 'edit',
						handle: () => {
							this.editProductWarehouse(this.selectedRow)
						},
						policyClaims: 'Warehouse_ProductWarehouse_Edit',
					},
					addButton: {
						title: this.$t('sale.warehouse.f.new'),
						shortcut: $sc.find('new'),
						icon: 'plus',
						isPrimary: false,
						visible: true,
						disabled: false,
						handle: (button, page, e) => {
							this.showModal({
								component: WarehouseModify
							}).then(() => { }).catch(() => { })
						},
						policyClaims: 'Warehouse_ProductWarehouse_Add',
					},
					deleteButton: {
						title: this.$t('delete'),
						shortcut: $sc.find('delete'),
						icon: 'trash',
						isPrimary: false,
						visible: true,
						disabled: true,
						handle: (button, page, e) => {
							this.showDeleteDialog()
						},
						policyClaims: 'Warehouse_ProductWarehouse_Delete',

					}
				},

			}
		},
		computed: {
			...mapGetters({
				warehouse_all: 'warehouses/all',
			}),
			warehouses() {

				if (this.data?.length)
					return this.data

				let cloned = _.cloneDeep(this.warehouse_all)
				return cloned
			},
			...mapState('appContext', {
				status: (state) => state,
			})
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
				},
			},
			selectedRow: {
				handler(val) {
					this.pageButtons.deleteButton.disabled = val ? false : true
				},
			},
		},

		created() {
			this.localSelectedItem = this.data
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
			let buttonsArray
			if (this.grandParentType() === 'modal') {
				buttonsArray = [this.pageButtons.selectButton, this.pageButtons.addButton, this.pageButtons.editButton, this.pageButtons.deleteButton,]
			} else {
				this.pageButtons.selectButton.visible = false
				buttonsArray = [this.pageButtons.addButton, this.pageButtons.editButton, this.pageButtons.deleteButton]
			}

			this.prepareWindow(this.$t('sale.warehouse.title'), buttonsArray)
			this.tableOptions.focusAndSelect.allowFocus = this.grandParentType() === 'modal'
			this.tableOptions.doubleClickedToSelect = this.grandParentType() === 'modal'
			this.tableOptions.enterToSelect = this.grandParentType() === 'modal'

		},
		methods: {
			...mapActions({
				warehouse_modify: 'warehouses/modify',
				broadcastRefresh: 'socket/broadcastRefresh'
			}),
			preSelectedRowData(data) {
				this.selectedRow = data
			},
			deleteWarehouse() {
				post(Endpoints.getUrl('sale.warehouse.delete'), { id: this.selectedRow.id }).then(() => {
					this.$toast(this.$t('sale.warehouse.m.delete.success', { code: this.selectedRow.code }), { type: 'success' })
					this.broadcastRefresh('Warehouses')
				})
			},
			showDeleteDialog() {
				if (_.isEmpty(this.selectedRow)) {
					this.$toast(this.$t('sale.warehouse.m.select'), { type: 'info' })
					return
				}
				dialog({
					title: this.$t('sale.warehouse.m.delete.title'),
					body: this.$t('sale.warehouse.m.delete.want-to-delete', {
						code: this.selectedRow.code,
					}),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.deleteWarehouse()
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			editProductWarehouse() {
				if (this.selectedRow) {
					this.showModal({
						component: WarehouseModify,
						data: this.selectedRow
					}).then(() => { }).catch(() => { })
				} else {
					this.$toast(this.$t('sale.warehouse.m.select'), { type: 'info' })
				}
			},
			rowDbClicked(val) {
				if (this.grandParentType() === 'modal')
					this.resolve(val)
			}
		},
	}
</script>
<style></style>
